import { call, select } from 'redux-saga/effects';
import { selectRoomId } from 'features/room/roomSlice';
import { importQuizCsvService, importQuizTemplateCsvService } from 'features/quizzes/services';
import { importQuizCsvRequested, importQuizTemplateCsvRequested } from 'features/quizzes/actions';
import { notification } from 'features/notifications/toast/notification';
import i18n from 'i18n';
import * as Sentry from '@sentry/react';
import { ApiError } from 'utils/http';

export function* importQuizCsvSaga(action: ReturnType<typeof importQuizCsvRequested>) {
  try {
    const roomId: string = yield select(selectRoomId);
    yield call(importQuizCsvService, roomId, action.payload);
  } catch (error) {
    if (error instanceof ApiError) {
      yield call(
        notification.error,
        error.message || i18n.t('notifications:quizzes.csv_import_validation_error')
      );
    } else {
      yield call(notification.error, i18n.t('notifications:quizzes.csv_import_error'));
      Sentry.captureException(error);
    }
  }
}

export function* importQuizTemplateCsvSaga(
  action: ReturnType<typeof importQuizTemplateCsvRequested>
) {
  try {
    const roomId: string = yield select(selectRoomId);
    yield call(importQuizTemplateCsvService, roomId, action.payload);
  } catch (error) {
    if (error instanceof ApiError) {
      yield call(
        notification.error,
        error.message || i18n.t('notifications:quizzes.csv_import_validation_error')
      );
    } else {
      yield call(notification.error, i18n.t('notifications:quizzes.csv_import_error'));
      Sentry.captureException(error);
    }
  }
}
